








import Vue from "vue";
import Layout from "@/layout/harvest-layout.json";
import { calculateCellPosition, isOutOfRange } from "@/utils/cell-calc";
import { CellPlacement } from "@/types/CellPlacement";
import { isSeed } from "../utils/placement-util";

export default Vue.extend({
  name: "PlacementDisplay",
  props: {
    isConnecting: {
      default: false
    },
    connectingSeedAlpha: {
      default: 0.3
    },
    placementOpacity: {
      default: (): Record<string, number> => ({})
    },
    size: { type: [Number], default: 20 },
    placement: {},
    linkPoint: {
      default: (): CellPlacement[] => []
    },
    connecting: {
      default: (): number[][] => []
    },
    connectingPlacement: {
      default: (): CellPlacement[] => []
    }
  },
  data() {
    return {
      cellData: Layout,
      backgroundColor: ["156, 39, 176", "245, 127, 23", "33, 150, 243", "158, 158, 158", "233, 30, 99", "76, 175, 80"]
    };
  },
  methods: {
    textStyle(placement: CellPlacement) {
      return {
        "font-size": placement.text.startsWith("E") ? "12px" : null,
        "z-index": this.linkPoint.includes(placement) ? 9 : null
      };
    },
    cellStyle(placement: CellPlacement) {
      const [xPos, yPos] = calculateCellPosition([+placement.x, +placement.y], this.size);
      const style = {
        height: `${this.size}px`,
        width: `${this.size}px`,
        top: `${xPos}px`,
        left: `${yPos}px`,
        "background-color": `rgba(${this.backgroundColor[placement.color ?? -1]}, ${
          this.placementOpacity[placement.text]
        })`,
        opacity: 1
      };

      if (
        this.isConnecting &&
        (isSeed(placement) ||
          isOutOfRange([+placement.x, +placement.y], this.connecting[0], 4) ||
          (this.connectingPlacement[0] && this.connectingPlacement[0].text != "P" && placement.text != "P"))
      ) {
        style.opacity = this.connectingSeedAlpha;
      }
      return style;
    }
  }
});
